<template>
  <router-view/>
</template>

<script lang="ts">
</script>

<style>
  #app{
    font-family: 'Raleway', sans-serif;
    min-height: 100vh;
  }
  i{
    cursor: pointer; 
  }
  .color{
    color: #C366FC;
  }
  .bg-color{
      background-color: #C366FC;
  }
</style>
